import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { PapiDeviation } from '@wix/da-papi-types';
import biLogger from '@wix/da-bi/pkg/BiLogger.logger';
import { BiData, BiEvent, ZoomModeBiEvent } from '@wix/da-bi/pkg/events';
import { getPublicSession } from '../../../publicSession/selectors';
import { getBiEventComponentByType } from '../../../DeviationPage/redux/helpers';
import { getDeviationResourceType, getDeviationType } from '../../_helpers';

/** Returns a callback that fires a ZoomModeBiEvent */
export function useZoomBiLogger(deviation: PapiDeviation): (isBeingZoomed: boolean) => void {
  const publicSession = useSelector(getPublicSession, () => true);

  return useCallback(
    (isBeingZoomed: boolean) => {
      const event: BiEvent = BiData<ZoomModeBiEvent>({
        evid: 303,
        view: !deviation.isPublished ? 'stash' : 'submission',
        component: getBiEventComponentByType(getDeviationType(deviation)),
        typeid: getDeviationResourceType(deviation),
        deviationid: deviation.deviationId,
        viewmode: isBeingZoomed ? 'zoom' : 'regular',
      });

      biLogger.log(publicSession, event);
    },
    [deviation, publicSession]
  );
}
